module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_7016.aa147ec5.png";